import { z } from 'zod'

export const idmAccMappingCreateSchema = z.object({
	idmGroup: z.string().min(1),
	accGroup: z.string().min(1),
	tool: z.string().min(1),
	roleInTool: z.string().optional(),
	provisioningMethod: z.string().default('manual_ticket'),
	isElevatedAccess: z.boolean().default(false),
	approvalRequired: z.boolean().default(false),
	approvalOwner: z.string().optional(),
	highRisk: z.boolean().default(false),
	notes: z.string().optional(),
})

export const idmAccMappingUpdateSchema = idmAccMappingCreateSchema.partial()

export type IdmAccMappingCreateInput = z.infer<typeof idmAccMappingCreateSchema>
export type IdmAccMappingUpdateInput = z.infer<typeof idmAccMappingUpdateSchema>
